module.exports = __webpack_public_path__ + "img/06.8a28e24f.png";